
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [
    {
        path: '/portfolio',
        name: 'portfolio',
        component: require('../pages/Portfolio.vue')
    },
    {
        path: '/project/:slug',
        name: 'project_details',
        component: require('../pages/Project.vue')
    },
    {
        path: '/presentation/:presentation',
        name: 'presentation',
        component: require('../pages/Portfolio.vue')
    },
];

export default new VueRouter({
    mode: 'history',
    routes
})



// WEBPACK FOOTER //
// ./resources/js/routes/index.js